// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__CurrencyView from "../../../html/CurrencyView.js";
import * as Buhta_cabinet__Dropdown from "../../../html/Dropdown.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__FieldNumber from "../../../../util/FieldNumber.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__ScrollableFlexItem from "../../../atoms/ScrollableFlexItem.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function CashboxCartPanel$EditItemDropdown(Props) {
  let item = Props.item;
  let index = Props.index;
  let onSave = Props.onSave;
  let onDelete = Props.onDelete;
  const match = React.useState(function () {
    return false;
  });
  const setIsDropdownShown = match[1];
  const match$1 = React.useState(function () {
    return item.name;
  });
  const setName = match$1[1];
  const name = match$1[0];
  const match$2 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.init(item.qty);
  });
  const setQty = match$2[1];
  const qty = match$2[0];
  const match$3 = React.useState(function () {
    return Buhta_cabinet__FieldNumber.init(item.item_price);
  });
  const setPrice = match$3[1];
  const price = match$3[0];
  const match$4 = React.useState(function () {
    return item.total_amount;
  });
  const setAmount = match$4[1];
  const amount = match$4[0];
  const resetValues = function (param) {
    Curry._1(setName, (function (param) {
      return item.name;
    }));
    Curry._1(setQty, (function (param) {
      return Buhta_cabinet__FieldNumber.init(item.qty);
    }));
    Curry._1(setAmount, (function (param) {
      return item.total_amount;
    }));
    Curry._1(setPrice, (function (param) {
      return Buhta_cabinet__FieldNumber.init(item.item_price);
    }));
  };
  React.useEffect((function () {
    Curry._1(setAmount, (function (param) {
      return Belt__Belt_Option.getWithDefault(qty.value, 0) * Belt__Belt_Option.getWithDefault(price.value, 0);
    }));
  }), [
    qty,
    price
  ]);
  const saveItem = function (ev) {
    ev.stopPropagation();
    const saleItem_item_type = item.item_type;
    const saleItem_item_id = item.item_id;
    const saleItem_item_price = Belt__Belt_Option.getWithDefault(price.value, 0);
    const saleItem_qty = Belt__Belt_Option.getWithDefault(qty.value, 0);
    const saleItem = {
      item_type: saleItem_item_type,
      item_id: saleItem_item_id,
      name: name,
      item_price: saleItem_item_price,
      qty: saleItem_qty,
      total_amount: amount
    };
    Curry._2(onSave, saleItem, index);
    Curry._1(setName, (function (param) {
      return name;
    }));
    Curry._1(setQty, (function (param) {
      return Buhta_cabinet__FieldNumber.init(Belt__Belt_Option.getWithDefault(qty.value, 0));
    }));
    Curry._1(setAmount, (function (param) {
      return amount;
    }));
    Curry._1(setPrice, (function (param) {
      return Buhta_cabinet__FieldNumber.init(Belt__Belt_Option.getWithDefault(price.value, 0));
    }));
    Curry._1(setIsDropdownShown, (function (param) {
      return false;
    }));
  };
  const activator = function (param) {
    return JsxRuntime.jsx("button", {
      children: JsxRuntime.jsx("img", {
        src: StaticAsset.src("/static/icons/edit.svg")
      }),
      className: "mr-2"
    });
  };
  const priceText = price.text;
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
    align: "BottomLeft",
    activator: activator,
    isDropdownShown: match[0],
    setIsDropdownShown: setIsDropdownShown,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_components__Text.H6.make, {
              className: "cart-dropdown--header text-default-gray",
              children: "" + name + " - " + priceText
            }),
            JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("img", {
                src: StaticAsset.src("/static/icons/close.svg")
              }),
              onClick: (function (param) {
                resetValues(undefined);
                Curry._1(setIsDropdownShown, (function (param) {
                  return false;
                }));
              })
            })
          ],
          className: "flex justify-between items-center"
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Наименование",
          type_: "text",
          onChange: (function (value) {
            Curry._1(setName, (function (param) {
              return value;
            }));
          }),
          isDarkMode: true,
          className: "mt-4",
          value: name
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Количество",
          type_: "text",
          onChange: (function (value) {
            Buhta_cabinet__FieldNumber.set(setQty, value);
          }),
          isDarkMode: true,
          className: "mt-4",
          value: qty.text
        }),
        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
          label: "Цена",
          type_: "text",
          onChange: (function (value) {
            Buhta_cabinet__FieldNumber.set(setPrice, value);
          }),
          isDarkMode: true,
          className: "mt-4",
          value: price.text
        }),
        JsxRuntime.jsx(Buhta_cabinet__Button.make, {
          className: "mt-4 bg-links hover:bg-links-hover active:bg-links-active",
          isWide: true,
          onClick: saveItem,
          children: "Сохранить"
        }),
        JsxRuntime.jsxs("button", {
          children: [
            JsxRuntime.jsx("img", {
              className: "w-6 h-6",
              src: StaticAsset.src("/static/icons/delete-red.svg")
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "ml-2 text-alert",
              children: "Удалить"
            })
          ],
          className: "mt-4 flex items-center",
          onClick: (function (param) {
            Curry._1(onDelete, index);
            Curry._1(setIsDropdownShown, (function (param) {
              return false;
            }));
          })
        })
      ],
      className: "p-4 pt-3 w-77.5"
    })
  });
}

const EditItemDropdown = {
  make: CashboxCartPanel$EditItemDropdown
};

function CashboxCartPanel$CartItemView(Props) {
  let item = Props.item;
  let index = Props.index;
  let isSelectionModeOpt = Props.isSelectionMode;
  let editableOpt = Props.editable;
  let onUpdateOpt = Props.onUpdate;
  let onDeleteOpt = Props.onDelete;
  let selectedOpt = Props.selected;
  let onSelectOpt = Props.onSelect;
  const isSelectionMode = isSelectionModeOpt !== undefined ? isSelectionModeOpt : false;
  const editable = editableOpt !== undefined ? editableOpt : true;
  const onUpdate = onUpdateOpt !== undefined ? onUpdateOpt : (function (param, param$1) {
      
    });
  const onDelete = onDeleteOpt !== undefined ? onDeleteOpt : (function (param) {
      
    });
  const selected = selectedOpt !== undefined ? selectedOpt : false;
  const onSelect = onSelectOpt !== undefined ? onSelectOpt : (function (param) {
      
    });
  const qty = item.qty;
  const name = item.name;
  const price = item.item_price;
  const amount = item.total_amount;
  return JsxRuntime.jsxs("div", {
    children: [
      isSelectionMode ? JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
          isChecked: selected,
          onChange: (function (param) {
            Curry._1(onSelect, !selected);
          }),
          className: "mr-4"
        }) : null,
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
            className: "name",
            children: "" + name
          }),
          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
            className: "mt-1",
            children: [
              JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                amount: price
              }),
              " x ",
              JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                className: "bg-warning rounded-11px px-1.5 py-0",
                children: Stdlib.string_of_float(qty) + (" " + "шт.")
              })
            ]
          })
        ],
        className: "grow mr-2"
      }),
      JsxRuntime.jsx(Buhta_components__Text.H5.make, {
        className: "total-price",
        children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
          amount: amount
        })
      }),
      editable && !isSelectionMode ? JsxRuntime.jsx(CashboxCartPanel$EditItemDropdown, {
          item: item,
          index: index,
          onSave: onUpdate,
          onDelete: onDelete
        }) : null
    ],
    className: "flex items-center px-6 py-3 hover:bg-gray-light cursor-pointer",
    onClick: isSelectionMode ? (function (param) {
        Curry._1(onSelect, !selected);
      }) : (function (param) {
        
      })
  });
}

const CartItemView = {
  make: CashboxCartPanel$CartItemView
};

function totalPrice(items) {
  return Belt__Belt_List.reduce(items, 0, (function (sum, item) {
    return sum + item.total_amount;
  }));
}

function CashboxCartPanel(Props) {
  let items = Props.items;
  let onSubmitOpt = Props.onSubmit;
  let onUpdate = Props.onUpdate;
  let onDelete = Props.onDelete;
  let onDeleteAll = Props.onDeleteAll;
  let kkm = Props.kkm;
  const onSubmit = onSubmitOpt !== undefined ? onSubmitOpt : (function (param) {
      
    });
  const totalPrice$1 = totalPrice(items);
  const p = kkm.preferences;
  const discountAllowed = p !== undefined ? p.allow_ui_markup_discount : false;
  const match = React.useState(function () {
    return false;
  });
  const setSelectionMode = match[1];
  const isSelectionMode = match[0];
  const match$1 = React.useState(function () {
    return /* [] */ 0;
  });
  const setSelectedItems = match$1[1];
  const selectedItems = match$1[0];
  const onSetSelectionMode = function (state) {
    if (state) {
      Curry._1(setSelectedItems, (function (param) {
        return Belt__Belt_List.mapWithIndex(items, (function (index, param) {
          return index;
        }));
      }));
    } else {
      Curry._1(setSelectedItems, (function (param) {
        return /* [] */ 0;
      }));
    }
    Curry._1(setSelectionMode, (function (param) {
      return state;
    }));
  };
  return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
    title: isSelectionMode ? "" : "Корзина",
    leftActions: {
      hd: Caml_obj.caml_equal(items, /* [] */ 0) ? null : JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
          isChecked: isSelectionMode,
          onChange: onSetSelectionMode,
          selectMode: isSelectionMode,
          text: "Выбрать"
        }),
      tl: /* [] */ 0
    },
    rightActions: {
      hd: isSelectionMode ? JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/delete.svg")
          }),
          onClick: (function (param) {
            Curry._1(onDeleteAll, selectedItems);
            onSetSelectionMode(false);
          })
        }) : null,
      tl: /* [] */ 0
    },
    shadowed: true,
    rounded: true,
    className: "panel--cart overflow-auto",
    children: items ? JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__ScrollableFlexItem.make, {
            children: JsxRuntime.jsx("div", {
              children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(items, (function (index, item) {
                const Key = "cart-item-" + String(index);
                return JsxRuntime.jsx(CashboxCartPanel$CartItemView, {
                  item: item,
                  index: index,
                  isSelectionMode: isSelectionMode,
                  onUpdate: onUpdate,
                  onDelete: onDelete,
                  selected: Belt__Belt_List.has(selectedItems, index, (function (item, index) {
                    return item === index;
                  })),
                  onSelect: (function (selected) {
                    if (selected) {
                      return Curry._1(setSelectedItems, (function (param) {
                        return {
                          hd: index,
                          tl: selectedItems
                        };
                      }));
                    } else {
                      return Curry._1(setSelectedItems, (function (param) {
                        return Belt__Belt_List.keep(selectedItems, (function (item) {
                          return item !== index;
                        }));
                      }));
                    }
                  })
                }, Key);
              }))),
              className: "grid"
            })
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "price-label title",
                children: "Итого"
              }),
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                className: "text-right",
                children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                  amount: totalPrice$1
                })
              }),
              discountAllowed ? JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "discount-label title",
                      children: "Скидка"
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                      className: "discount-value value",
                      children: "-"
                    })
                  ]
                }) : null
            ],
            className: "grid grid-cols-1-auto px-6 py-4 border border-solid border-gray-main"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
            size: "xl",
            className: "p-9 rounded-tl-none rounded-tr-none rounded-br-md rounded-bl-md",
            isWide: true,
            onClick: (function (param) {
              Curry._1(onSubmit, undefined);
            }),
            children: JsxRuntime.jsxs(Buhta_components__Text.H2.make, {
              className: "text-white",
              children: [
                "Оплатить ",
                JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                  amount: totalPrice$1
                })
              ]
            })
          })
        ],
        className: "flex flex-col h-full"
      }) : JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-30 h-30",
                src: StaticAsset.src("/static/images/cart-empty.png")
              }),
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "mt-4 text-gray-medium",
                children: "Корзина пуста"
              })
            ],
            className: "grow flex flex-col items-center justify-center"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
            size: "xl",
            className: "p-9 rounded-tl-none rounded-tr-none rounded-br-md rounded-bl-md",
            disabled: true,
            isWide: true,
            children: JsxRuntime.jsxs(Buhta_components__Text.H2.make, {
              className: "text-white",
              children: [
                "Оплатить ",
                JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                  amount: totalPrice$1
                })
              ]
            })
          })
        ],
        className: "flex flex-col h-full items-center justify-center"
      })
  });
}

const make = CashboxCartPanel;

export {
  EditItemDropdown,
  CartItemView,
  totalPrice,
  make,
}
/* Buhta_cabinet__Button Not a pure module */
